import EnterpriseAssociatedTable from "../Components/Table/EnterpriseAssociatedTable"
import useGet from "../Hooks/useGet"
import API_ENDPOINTS from "../Config/api";
import { useState, useEffect } from "react";
import DescriptionBanner from "../Components/DescriptionBanner";

export default function EnterpriseConsent(params) {


    const [associatedEnterprises, setAssociatedEnterprisesAPI] = useState()
    const { fetchedData: associatedEnterprisesAPI } = useGet(API_ENDPOINTS.getAssociatedEnterprises);
    useEffect(() => { setAssociatedEnterprisesAPI(associatedEnterprisesAPI) }, [associatedEnterprisesAPI])


    return (
        <div className="space-y-6 p-6 items-stretch" data-tour="enterprise-content">

            <DescriptionBanner title='Richieste di Monitoraggio' description={'Di seguito le richieste delle aziende enterprise per il monitoraggio della tua postura di sicurezza.'} />

            <EnterpriseAssociatedTable
                data={associatedEnterprises}
                setData={setAssociatedEnterprisesAPI}
            />

        </div>
    )
}